import { render, staticRenderFns } from "./parameterDataDictionary.vue?vue&type=template&id=4a9b7f95&scoped=true"
import script from "./parameterDataDictionary.vue?vue&type=script&lang=js"
export * from "./parameterDataDictionary.vue?vue&type=script&lang=js"
import style0 from "./parameterDataDictionary.vue?vue&type=style&index=0&id=4a9b7f95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9b7f95",
  null
  
)

export default component.exports